/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Success_DeletedInputs */

const he_posts_success_deleted = /** @type {(inputs: Posts_Success_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פוסט נמחק`)
};

const en_posts_success_deleted = /** @type {(inputs: Posts_Success_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post deleted`)
};

/**
* | output |
* | --- |
* | "Post deleted" |
*
* @param {Posts_Success_DeletedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const posts_success_deleted = /** @type {((inputs?: Posts_Success_DeletedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Success_DeletedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_success_deleted(inputs)
	return en_posts_success_deleted(inputs)
});